var map = {
	"./certificate_automatic_frame.png": 211,
	"./certificate_ects_frame.png": 212,
	"./certificate_frame.png": 213,
	"./certificate_verified_frame.png": 214,
	"./frame_blue_de.png": 215,
	"./frame_blue_en.png": 216,
	"./frame_gold_de.png": 217,
	"./frame_gold_en.png": 218,
	"./frame_green_de.png": 219,
	"./frame_green_en.png": 220,
	"./generic_audit_sample.jpg": 221,
	"./generic_bundle_sample.jpg": 222,
	"./generic_coa_ects_sample.jpg": 223,
	"./generic_coa_sample.jpg": 224,
	"./generic_sop_sample.jpg": 225,
	"./milestone_completed.png": 226,
	"./milestone_completed.svg": 227,
	"./milestone_completed_small.svg": 228,
	"./milestone_uncompleted.png": 229,
	"./milestone_uncompleted.svg": 230,
	"./milestone_uncompleted_old.png": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;